import { render, staticRenderFns } from "./SideWrap.vue?vue&type=template&id=3ab39e61&"
import script from "./SideWrap.vue?vue&type=script&lang=js&"
export * from "./SideWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports